'use strict';
// comes from int_adyen_custom/**/client/**/adyen/constants.js
const adyenConstants = require('./adyen/constants');
let result = {
    ADYEN: adyenConstants,
    UPS: {
        UPS_ADDR_VERIFY_NOT_CALLED: '0',
        UPS_ADDR_VERIFY_FAILED: '1',
        UPS_ADDR_VERIFY_EXACT_MATCH: '2',
        UPS_ADDR_VERIFY_NO_RECOMMENDATIONS: '3',
        UPS_ADDR_VERIFY_USER_IGNORED_REC: '4',
        UPS_ADDR_VERIFY_USER_ACCEPTED_REC: '5'
    },
    SHIPPING_TYPES: {
        HOME: 'address',
        ACCESS_POINT: 'accessPoint',
        BOPIS: 'buyOnlinePickupInStore',
        WILL_CALL: 'willCall',
        SHIPPING_OPTION_PICK_UP: 'pickUpAtLocation'
    },
    SELECTORS: {
        accordions: '.checkout-accordion',
        adyenCreditCardHolderInput: '.adyen-checkout__card__holderName__input',
        sectionEmail: '.email-section',
        sectionShipping: '.checkout-accordion.single-shipping',
        sectionBilling: '.checkout-accordion.payment-form',
        sectionReview: '.checkout-accordion.review',
        sectionHeadings: '.section-heading',
        shippingForm: '.checkout-accordion.single-shipping .checkout-accordion__form, .email-section, .account-banner-container, .express-payments-checkout',
        shippingSummary: '.checkout-accordion.single-shipping .checkout-accordion__summary',
        billingForm: '.checkout-accordion.payment-form .checkout-accordion__form',
        billingSummary: '.checkout-accordion.payment-form .checkout-accordion__summary',
        submitPaymentBtn: '.submit-payment',
        reviewSummary: '.checkout-accordion.review .checkout-accordion__summary',
        orderSummary: '.order-summary'
    },
    STAGES: {
        shipping: 'shipping',
        billing: 'billing',
        review: 'review'
    },
    PAYMENT_METHODS: {
        GIFT_CERTIFICATE: 'GIFT_CERTIFICATE',
        LOYALTY: 'LOYALTY',
        PROMOTION_ONLY_ORDER: 'PromotionOnlyOrder',
        ADYEN_COMPONENT: adyenConstants.METHOD_ADYEN_COMPONENT,
        ADYEN_POS: adyenConstants.METHOD_ADYEN_POS,
        PAYBYLINK: 'PayByLink',
        PAYPAL: 'PayPal',
        CREDIT_CARD: 'CREDIT_CARD'
    }
};

result.ADYEN.SUPPORTED_PAYMENTS = ['scheme', 'klarna', 'storedCard'];

module.exports = result;
